// src/routes/HRRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Shop Management
import CommissionConfigPage from '../pages/employeeCommission/CommissionConfigPage';
import EmployeeCommissionReport  from '../pages/employeeCommission/EmployeeCommissionReport';
import MyCommissionReport from '../pages/employeeCommission/MyCommissionReport';

const HRRoutes = () => {
  return (
    <Routes>
      {/* Shop Management Routes */}
      <Route 
        path="/commission/config" 
        element={
            <PermissionRoute requiredPermission="view_all_shops">
              <CommissionConfigPage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/commission/report" 
        element={
            <PermissionRoute requiredPermission="create_shop">
              <EmployeeCommissionReport />
            </PermissionRoute>
        } 
      />
      <Route
        path="/commission/my-report"
        element={<MyCommissionReport />}
        // No PermissionRoute — every logged-in user can view their own commission
      />
    </Routes>
  );
};

export default HRRoutes;